import { Decimal } from '../../datastructures';
import { createAsyncAtom } from '../../lib/state';

export interface SwapInputState {
  inputAmount: string;
  sellAmount: Decimal;
}

const SWAP_INPUT_DEFAULT: SwapInputState = {
  inputAmount: '',
  sellAmount: Decimal.ZERO,
};

export const swapInputAtom = createAsyncAtom<SwapInputState>(async () => SWAP_INPUT_DEFAULT);

export function setSwapInputAmount(inputAmount: string) {
  const current = swapInputAtom.getResolvedValue() ?? SWAP_INPUT_DEFAULT;
  swapInputAtom.setValue({ ...current, inputAmount });
}

export function setSwapSellAmount(sellAmount: Decimal) {
  const current = swapInputAtom.getResolvedValue() ?? SWAP_INPUT_DEFAULT;
  swapInputAtom.setValue({ ...current, sellAmount });
}

export function resetSwapInput() {
  swapInputAtom.setValue(SWAP_INPUT_DEFAULT);
}
